// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__gqxhO","header":"ReportDetails_header__20eRC","title":"ReportDetails_title__2W3tf","left":"ReportDetails_left__2KH5r"};